import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';

import {
  CmBox,
  CmButton,
  CmFormControl,
  CmFormErrorMessage,
  CmFormLabel,
  CmInput,
  CmInputGroup,
  CmInputRightElement,
} from '@/components/uiParts';
import { useInput } from '@/hooks/Form';

interface Props {
  onSubmit: (password: string, passwordConfirmation: string) => Promise<void>;
}

export const ResetPasswordForm: React.FC<Props> = ({
  onSubmit,
}): JSX.Element => {
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const [password, passwordProps] = useInput(
    '',
    isShowPassword ? 'text' : 'password'
  );
  const [isShowPasswordConfirmation, setIsShowPasswordConfirmation] =
    useState<boolean>(false);
  const [confirmPassword, confirmPasswordProps] = useInput(
    '',
    isShowPasswordConfirmation ? 'text' : 'password'
  );
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const isPasswordMatch = () => password === confirmPassword;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);

    if (!isPasswordMatch()) return setErrorMessage('パスワードが一致しません');

    await onSubmit(password, confirmPassword);
  };

  return (
    <CmBox as="form" mx={4} onSubmit={handleSubmit}>
      <CmFormControl mb={8}>
        <CmFormLabel>新パスワード</CmFormLabel>
        <CmInputGroup>
          <CmInput {...passwordProps} isRequired />
          <CmInputRightElement>
            <CmBox onClick={() => setIsShowPassword((prev) => !prev)}>
              {isShowPassword ? (
                <ViewOffIcon cursor="pointer" />
              ) : (
                <ViewIcon cursor="pointer" />
              )}
            </CmBox>
          </CmInputRightElement>
        </CmInputGroup>
      </CmFormControl>
      <CmFormControl mb={8} isInvalid={errorMessage !== null}>
        <CmFormLabel>新パスワード（確認用）</CmFormLabel>
        <CmInputGroup>
          <CmInput {...confirmPasswordProps} isRequired />
          <CmInputRightElement>
            <CmBox
              onClick={() => setIsShowPasswordConfirmation((prev) => !prev)}
            >
              {isShowPasswordConfirmation ? (
                <ViewOffIcon cursor="pointer" />
              ) : (
                <ViewIcon cursor="pointer" />
              )}
            </CmBox>
          </CmInputRightElement>
        </CmInputGroup>
        <CmFormErrorMessage>{errorMessage}</CmFormErrorMessage>
      </CmFormControl>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton type="submit" width="100%" textAlign="center" mb={3}>
        パスワードを再設定する
      </CmButton>
    </CmBox>
  );
};
